<template>
  <FormKit type="select" label="Position" v-model="modelValue" :options="positions" />
</template>

<script lang="ts" setup>
import { useVModels } from '@vueuse/core';
import { positions as positionsList } from '~/lib/enums/positions';
const props = defineProps<{
  modelValue: string;
}>();
const positions = ref(
  [{ value: '', label: 'All' }].concat(positionsList.map((p) => p && p.position))
);
const emit = defineEmits(['update:modelValue']);
const { modelValue } = useVModels(props, emit);
</script>
